<template>
  <modal
    :header-text="$t('watermarkModal.header')"
    :hide-footer="true"
    @close="close"
  >
    <div :class="$style.container">
      <div :class="$style.row">
        <label :class="$style.checkboxLabel">
          <input
            v-model="watermarkEnabled"
            type="checkbox"
          >
          <span>{{ $t('watermarkModal.displayWatermark') }}</span>
        </label>
      </div>

      <div :class="$style.row">
        <div :class="$style.label">
          {{ $t('watermarkModal.typeLabel') }}
        </div>

        <select
          v-model="showType"
          :class="$style.select"
        >
          <option :value="0">
            {{ $t('watermarkModal.text') }}
          </option>
          <option :value="1">
            QR
          </option>
        </select>
      </div>

      <div :class="$style.row">
        <label :class="$style.checkboxLabel">
          <input
            v-model="onlyForConfidencial"
            type="checkbox"
          >
          <span>{{ $t('watermarkModal.confidentialOnly') }}</span>
        </label>
      </div>
    </div>
  </modal>
</template>

<script>
  import Modal from '@/components/common/modal/settings-modal.vue';

  export default {
    components: { Modal },
    props: {
      data: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      watermarkEnabled: {
        get() {
          return this.data.enabled;
        },
        set(value) {
          this.updateSetting('enabled', value);
        },
      },

      showType: {
        get() {
          return +this.data.showtype;
        },
        set(value) {
          this.updateSetting('showtype', value);
        },
      },

      onlyForConfidencial: {
        get() {
          return this.data.onlyforconfidencial;
        },
        set(value) {
          this.updateSetting('onlyforconfidencial', value);
        },
      },
    },
    methods: {
      close() {
        this.$emit('close');
      },

      updateSetting(key, value) {
        this.$emit('update', key, value);
      },
    },
  };
</script>

<style lang="scss" module>
  .container {
    padding: 0 20px;
  }

  .row {
    display: flex;
    align-items: center;
    margin: 15px 0;
    gap: 10px;
  }

  .label {
    min-width: 150px;
    font-size: 14px;
  }

  .select {
    padding: 5px 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 2px;
    flex: 1;
  }

  .input {
    padding: 5px 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 2px;
    width: 100px;
  }

  .checkboxLabel {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
  }
</style>
